import { FileX2Icon } from 'lucide-react'

import { ActionRow } from '../../components/action-row/ActionRow'
import { ActionRowBaseProps } from '../../components/action-row/types'
import { ResetApprovalAction } from './types'

export interface ResetApprovalActionRowProps extends ActionRowBaseProps {
  action: ResetApprovalAction
}

export function ResetApprovalActionRow({ action, ...props }: ResetApprovalActionRowProps) {
  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={FileX2Icon} />

      <ActionRow.Title>
        <ActionRow.Title.Tokens tokens={[action.token]} />
        Reset approval for {action.token.symbol}
      </ActionRow.Title>

      <ActionRow.Amount token={action.token} amount={action.value} />

      <ActionRow.ErrorWarning />

      <ActionRow.Trigger>Reset Approval</ActionRow.Trigger>
    </ActionRow>
  )
}
